import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.action.disabledBackground}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
  },
  label: {
    fontSize: 13,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  canvasWrapper: {
    position: 'relative',
    width: '100%',
    height: 150,
    border: `1px dashed ${theme.palette.action.disabled}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  canvas: {
    width: '100%',
    height: '100%',
    cursor: 'crosshair',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  saveButton: {
    minWidth: 80,
  },
  preview: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  previewImage: {
    height: 60,
    border: `1px solid ${theme.palette.action.disabledBackground}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  timestamp: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
  error: {
    borderColor: theme.palette.error.main,
  },
}));

export default useStyles;
